import { arrayRemove } from './array/arrayRemove.js';
/**
 * Creates a new event emitter instance with emit functionality.
 * @util
 * @template TEvent - The type of event data that will be emitted (defaults to void)
 * @returns An object containing the event emitter and emit functions
 * @example
 * ```typescript
 * const { event, emit, emitAsync } = createEventEmitter<string>();
 *
 * event.on((message) => console.log(message));
 * emit('Hello World'); // Logs: Hello World
 * await emitAsync('Async Hello'); // Logs: Async Hello
 * ```
 */
export function createEventEmitter() {
    const listeners = [];
    const event = {
        on: callback => {
            listeners.push(callback);
        },
        off: callback => {
            arrayRemove(listeners, callback);
        },
    };
    const emit = ((...args) => {
        for (const callback of listeners) {
            void callback(...args);
        }
    });
    const emitAsync = async (...args) => {
        for (const callback of listeners) {
            await callback(...args);
        }
    };
    return {
        event,
        emit: emit,
        emitAsync: emitAsync,
    };
}
//# sourceMappingURL=createEventEmitter.js.map